import * as React from "react";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import bg from "../../assets/BG.png";
import logo from "../../assets/logohims.png";
import { useNavigate } from "react-router-dom";
import gbr from "../../assets/PHOTO.png";
import ApiService from "../../services/ApiService";
import { useAuth } from "oidc-react";
import { CircularProgress } from "@mui/material";
import SnackbarCustom from "../../components/SnackbarCustom";
import useLoginStatus from "../../hooks/useLoginStatus";

export default function Login({ isCallback = false }) {
  const { signIn, isLoading: authLoading, userData } = useAuth();
  const {
    isLoggedIn,
    loading: localAuthLoading,
    redirectAfterLogin,
    deleteRedirectLocation,
  } = useLoginStatus();
  const history = useNavigate();
  const [snackbar, setSnackbar] = React.useState({
    isOpen: false,
    message: "",
  });

  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);

    const param = {
      email: data.get("userName"),
      password: data.get("password"),
    };
    ApiService.getJwt(param)
      .then((res) => {
        // alert(JSON.stringify(res.data.payload.token) );
        var result = res.data;
        if (result.isOk) {
          localStorage.setItem("token", JSON.stringify(result.payload.token));
          localStorage.setItem(
            "userName",
            JSON.stringify(data.get("userName"))
          );
          history("/hsse");
        } else {
          alert(result.message);
        }
      })
      .catch(() => {
        alert("error");
      });
  };

  const onLogin = (e) => {
    e.preventDefault();
    signIn();
  };

  const loginIdaman = async (tokenIdaman, userId) => {
    try {
      const res = await ApiService.loginIdaman(tokenIdaman, userId);
      // console.log("balikan login idaman", res.data);
      if (!res.data.isOk) throw res.data.message;

      localStorage.setItem("token", JSON.stringify(res.data.payload.token));
      localStorage.setItem(
        "roleName",
        JSON.stringify(res.data.payload.roleName)
      );
      localStorage.setItem(
        "displayName",
        JSON.stringify(res.data.payload.displayName)
      );
      localStorage.setItem("jabatan", JSON.stringify(res.data.payload.jabatan));
      localStorage.setItem("photo", JSON.stringify(res.data.payload.photo));
      history(redirectAfterLogin ? redirectAfterLogin : "/hsse");
      deleteRedirectLocation();
    } catch (error) {
      console.log("error", error);
      setSnackbar({ isOpen: true, message: error });
      setTimeout(() => history("/"), 300);
    }
  };

  React.useEffect(() => {
    if (localAuthLoading || !isLoggedIn) return;

    history("/hsse");
  }, [localAuthLoading]);

  React.useEffect(() => {
    if (!isCallback || authLoading) return;

    loginIdaman(userData.access_token, userData.profile.sub);
  }, [authLoading]);

  return (
    <>
      <Grid
        container
        spacing={0}
        direction="column"
        alignItems="center"
        justifyContent="center"
        style={{ minHeight: "100vh" }}
        sx={{
          backgroundImage: `url(${bg})`,
          backgroundRepeat: "no-repeat",
          backgroundColor: (t) =>
            t.palette.mode === "light"
              ? t.palette.grey[50]
              : t.palette.grey[900],
          backgroundSize: "cover",
          backgroundPosition: "center",
          position: "relative",
        }}
      >
        <CssBaseline />
        <Grid item xs={3} width={800}>
          <Grid
            container
            component={Paper}
            height={300}
            style={{ borderRadius: 10 }}
          >
            <Grid item xs={5}>
              <Box
                sx={{
                  my: 6,
                  mx: 8,
                  width: "60%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <img src={logo} width="150" alt="logo" />
                <Box
                  component="form"
                  validate
                  onSubmit={onLogin}
                  sx={{ mt: 1 }}
                >
                  {/* <TextField
                  variant="standard"
                  margin="normal"
                  required
                  fullWidth
                  id="email"
                  label="User Name"
                  name="userName"
                  // autoComplete="email"
                  autoFocus
                />
                <TextField
                  variant="standard"
                  margin="normal"
                  required
                  fullWidth
                  name="password"
                  label="Password"
                  type="password"
                  id="password"
                  autoComplete="current-password"
                /> */}
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    sx={{ mt: 3, mb: 2 }}
                    style={{ borderRadius: 50 }}
                  >
                    Login
                  </Button>
                </Box>
              </Box>
            </Grid>
            <Grid
              item
              xs={7}
              style={{
                borderRadius: 10,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img
                src={gbr}
                style={{
                  height: 280,
                  width: 450,
                  objectFit: "cover",
                  borderRadius: 10,
                }}
              />
            </Grid>
          </Grid>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: 15,
            }}
          >
            <a
              style={{
                color: "#fff",
                fontSize: 18,
                textDecorationLine: "none",
              }}
              href="https://apps.pertamina.com/hims/"
              target="_blank"
            >
              Daftar HSSE Passport
            </a>
            <a
              style={{
                color: "#fff",
                fontSize: 18,
                textDecorationLine: "none",
              }}
              href="https://www.moriv.id/FTW-Online/Account/Login?ReturnUrl=%2FFTW-Online%2FUser"
              target="_blank"
            >
              FTW Online
            </a>
            <a
              style={{
                color: "#fff",
                fontSize: 18,
                textDecorationLine: "none",
              }}
              href="https://apps.pertamina.com/clsr"
              target="_blank"
            >
              Test CLSR
            </a>
          </div>
        </Grid>
        {isCallback ? (
          <div
            style={{
              position: "absolute",
              zIndex: 999,
              width: "100%",
              height: "100%",
              backgroundColor: "#000",
              opacity: "70%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CircularProgress size={100} thickness={5} />
          </div>
        ) : null}
      </Grid>
      {/* SNACKBAR */}
      <SnackbarCustom
        duration={3000}
        type={snackbar.type || "warning"}
        open={snackbar.isOpen}
        onClose={() => setSnackbar({ ...snackbar, isOpen: false })}
        message={snackbar.message}
      />
    </>
  );
}
